document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.site-nav__item--has-mega');

  items.forEach(item => {
    const toggle = item.querySelector('.site-nav__link');
    const panel  = item.querySelector('.mega-menu');

    if (!toggle || !panel) return;

    // Desktop: open on hover
    item.addEventListener('mouseenter', () => {
      item.classList.add('is-open');
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('is-open');
    });

    // Keyboard focus
    toggle.addEventListener('focus', () => {
      item.classList.add('is-open');
    });

    panel.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) {
        item.classList.remove('is-open');
      }
    });
  });
});

